'use client';

import { Product } from 'shared/types/product/Product';
import PadiProductHeaderSection, { ProductHeaderSectionProps } from 'components/padi-product/header-section';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';

const PadiSubscriptionHeaderSectionTastic = ({
  data,
}: TasticProps<DataSource<{ product: Product }> & ProductHeaderSectionProps>) => {
  if (!data?.data?.dataSource?.product) return null;

  return (
    <PadiProductHeaderSection
      product={data?.data?.dataSource.product}
      attributeSection={data?.attributeSection}
      titleHtag={data?.titleHtag}
      titleSize={data?.titleSize}
      bgColor={data?.bgColor}
      textAlign={data?.textAlign}
    />
  );
};

export default PadiSubscriptionHeaderSectionTastic;
